import { render, staticRenderFns } from "./UserDataInfo.vue?vue&type=template&id=5022c87a&scoped=true"
import script from "./UserDataInfo.vue?vue&type=script&lang=js"
export * from "./UserDataInfo.vue?vue&type=script&lang=js"
import style0 from "./UserDataInfo.vue?vue&type=style&index=0&id=5022c87a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5022c87a",
  null
  
)

export default component.exports